import { FC, ReactNode } from 'react';

import { cn } from '@/utils/styleUtils.ts';

interface Props {
    children: ReactNode;
    text?: string; // only for storybook
    className?: string;
}

const Heading3: FC<Props> = ({ children, text, className }) => {
    return <h3 className={cn('', className)}>{text ?? children}</h3>;
};

export default Heading3;
